import normalizeComponent from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './TreeSelect.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { ref: "target" },
    [
      _c(
        "TextField",
        {
          staticClass: "text-field",
          attrs: {
            "is-focused": _vm.focused,
            "is-invalid": _vm.isInvalid,
            "is-loading": _vm.isLoading,
            select: "",
            tabindex: "-1"
          },
          on: { click: _vm.click }
        },
        [
          _c(
            "div",
            {
              ref: "list",
              staticClass: "flex-wrapper",
              on: {
                dragover: function($event) {
                  $event.preventDefault();
                }
              }
            },
            [
              _c("input", {
                ref: "input",
                staticClass: "search",
                style: { width: _vm.currentWidth },
                attrs: { disabled: _vm.isLoading },
                domProps: { value: _vm.search },
                on: {
                  keydown: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault();
                      return _vm.onNextSuggestion($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault();
                      return _vm.onPreviousSuggestion($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "right", 39, $event.key, [
                          "Right",
                          "ArrowRight"
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 2) {
                        return null
                      }
                      $event.preventDefault();
                      return _vm.toggleExpand($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "left", 37, $event.key, [
                          "Left",
                          "ArrowLeft"
                        ])
                      ) {
                        return null
                      }
                      if ("button" in $event && $event.button !== 0) {
                        return null
                      }
                      $event.preventDefault();
                      return _vm.toggleExpand($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.onSuggestionSelected($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "delete", [8, 46], $event.key, [
                          "Backspace",
                          "Delete",
                          "Del"
                        ])
                      ) {
                        return null
                      }
                      return _vm.removeOption($event)
                    }
                  ],
                  input: _vm.onInput,
                  focus: _vm.onFocus,
                  blur: _vm.onBlur,
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "esc", 27, $event.key, [
                        "Esc",
                        "Escape"
                      ])
                    ) {
                      return null
                    }
                    return _vm.onEsc($event)
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          !_vm.selected.length
            ? _c(
                "div",
                { staticClass: "text" },
                [
                  !_vm.search && _vm.selected && _vm.$scopedSlots["selected"]
                    ? _vm._t("selected", null, {
                        ancestors: _vm.ancestors,
                        selected: _vm.selected
                      })
                    : _c(
                        "span",
                        {
                          attrs: {
                            placeholder: !_vm.search && !_vm.selected.label
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.input) +
                              "\n            "
                          )
                        ]
                      )
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Icons", {
            attrs: {
              "is-selected": _vm.isAnyOptionSelected,
              "is-fetching": _vm.isFetching,
              "is-clearable": _vm.isClearable
            },
            on: { clear: _vm.onClear }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpen && !_vm.isDirty
        ? _c(
            "Popper",
            {
              ref: "menu",
              attrs: {
                offset: "0,0",
                "target-element": _vm.$refs.target,
                "boundaries-element": _vm.boundariesElement,
                placement: "bottom-start"
              }
            },
            [
              _c("SelectMenu", {
                style: { width: _vm.selectWidth },
                attrs: {
                  selected: _vm.selected,
                  options: _vm.options,
                  "current-suggestion-id": _vm.currentSuggestionId,
                  "is-fetching": _vm.isFetching,
                  async: _vm.async,
                  search: _vm.search,
                  "contains-query": !!_vm.search,
                  "has-suggestions": true,
                  "no-options-message": _vm.noOptionsMessage,
                  placeholder: _vm.searchPromptText
                },
                on: {
                  mouseover: _vm.onMouseOverSuggestion,
                  "option-selected": _vm.onOptionSelected
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "option",
                      fn: function(ref) {
                        var option = ref.option;
                        var isCurrent = ref.isCurrent;
                        return _vm._t("option", null, {
                          isCurrent: isCurrent,
                          option: option
                        })
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-0d596465";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/TreeSelect/TreeSelect.vue.js